// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"490":"31d967b6fb66de33","537":"24f02c35a0c31e69"}[chunkId] + ".js";
};